import * as yup from 'yup';

export const CreateEnrollmentRequiredDocumentFormValidation = yup.object().shape({
    description: yup.string().required('Tipo de documento é obrigatório')
});